import { RESET_CART, GET_CART } from './actionTypes';

import cartRemote from '../../api/cartRemote';

import Cart from '../../models/Cart';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import CartServiceServerParams from '../../models/CartServiceServerParams';

import { receiveError } from './notificationAction';

function restSuccess() {
  return {
    type: RESET_CART
  };
}

function cartSuccess(cart: Cart) {
  return {
    type: GET_CART,
    data: cart
  };
};

function resetCart() {

  return (dispatch: Function) => {

    dispatch(restSuccess());
  };
}

function updateServicesToCart(awbCode: string, awbNumber: string, params: Array<CartServiceServerParams>, isExport?: boolean, type?: string) {

  return (dispatch: Function) => {

    cartRemote.updateServiceToCart(awbCode, awbNumber, params[0], isExport, type).then((resp: ApiResponse<Cart>) => {
      if (params.length > 1) {
        cartRemote.updateServiceToCart(awbCode, awbNumber, params[1], isExport, type).then((resp: ApiResponse<Cart>) => {
          handleCartResponse(resp, dispatch);
        });
      } else {
        handleCartResponse(resp, dispatch);
      }
    });

    /* TODO: Uncomment that when BE is able to handle asynchronous cart editing requests.
              Currently it will work only for max length of two services, which is enough for now.
    let promisesList: Promise<ApiResponse<Cart>>[] = [];
    params.forEach(param => {
      promisesList.push(cartRemote.updateServiceToCart(awbCode, awbNumber, param));
    });
    
    Promise.all(promisesList).then((resp: ApiResponse<Cart>[]) => {

      cartRemote.getCart().then((resp: ApiResponse<Cart>) => {
        handleCartResponse(resp, dispatch);
      });
    });
    */
  };
};

function addServiceToCart(awbCode: string, awbNumber: string, version: number, params: Array<CartServiceServerParams>, isExport?: boolean, type?: string) {

  return (dispatch: Function) => {

    cartRemote.addServiceToCart(awbCode, awbNumber, version, params, isExport, type).then((resp: ApiResponse<Cart>) => {

      if (resp.error && resp.error.errorCode === '#awbNotFound') {
        const addAwbReq = isExport ? 
          cartRemote.addExportAirwayBillToCart(awbCode, awbNumber, version, true) : 
          cartRemote.addAirwayBillToCart(awbCode, awbNumber, version, undefined, true);
          
        addAwbReq.then((addAwbResp: any) => {
          if (addAwbResp.error) {
            handleCartResponse({ result: undefined, error: addAwbResp.error }, dispatch);
          } else {
            cartRemote.addServiceToCart(awbCode, awbNumber, version, params, isExport, type).then((finalResp: ApiResponse<Cart>) => {
              handleCartResponse(finalResp, dispatch);
            });
          }
        });
      } else {
        handleCartResponse(resp, dispatch);
      }
    });
  };
};

function deleteServiceFromCart(awbCode: string, awbNumber: string, service: string, reason?: string, isExport?: boolean, type?: string) {

  return (dispatch: Function) => {
    cartRemote.deleteServiceFromCart(awbCode, awbNumber, service, reason, isExport, type).then((resp: ApiResponse<Cart>) => {

      handleCartResponse(resp, dispatch);
    });
  };
};

function receiveCart(isGo?: boolean) {

  return (dispatch: Function) => {

    cartRemote.getCart(isGo).then((resp: ApiResponse<Cart>) => {

      handleCartResponse(resp, dispatch);
    });
  };
};

function addAirwayBillToCart(code: string, number: string, version: number) {

  return (dispatch: Function) => {

    cartRemote.addAirwayBillToCart(code, number, version).then((resp: ApiResponse<Cart>) => {

      handleCartResponse(resp, dispatch);
    });
  };
};

function addAirwayBillPartToCart(code: string, number: string, partId: string) {

  return (dispatch: Function) => {

    cartRemote.addAirwayBillPartToCart(code, number, partId).then((resp: ApiResponse<Cart>) => {

      handleCartResponse(resp, dispatch);
    });
  };
};

function updateWholeCart(cart: Cart) {

  return (dispatch: Function) => {

    dispatch(cartSuccess(cart));
  };
};

function deleteAwbFromCart(code: string, number: string) {

  return (dispatch: Function) => {

    cartRemote.deleteAwbFromCart(code, number).then((resp: ApiResponse<Cart>) => {

      handleCartResponse(resp, dispatch);
    });
  };
};

export {
  resetCart,
  receiveCart,
  addAirwayBillToCart,
  addAirwayBillPartToCart,
  addServiceToCart,
  updateWholeCart,
  deleteAwbFromCart,
  updateServicesToCart,
  deleteServiceFromCart
};

function handleCartResponse(resp: ApiResponse<Cart>, dispatch: Function): void {

  const cart: Cart | undefined = resp.result;
  const error: ResponseError | undefined = resp.error;

  if (cart) {
    dispatch(cartSuccess(cart));
  };

  if (error) {
    dispatch(receiveError(error));
  };
};